import type { GradeColumn, ReviewMatrixProductItem } from "@/types/review";

export function compareProducts(
  a: ReviewMatrixProductItem,
  b: ReviewMatrixProductItem,
): number {
  const aName = a.product_name ?? "";
  const bName = b.product_name ?? "";
  if (aName < bName) return -1;
  if (aName > bName) return 1;
  return a.product_id - b.product_id;
}

export function compareColumns(a: GradeColumn, b: GradeColumn): number {
  const aGrade = a.grade_name ?? "";
  const bGrade = b.grade_name ?? "";
  if (aGrade < bGrade) return -1;
  if (aGrade > bGrade) return 1;
  return a.fingerprint.localeCompare(b.fingerprint);
}
